import { useEffect, useRef } from 'react'
import { sum } from '@10000/common'
import './WheelPin.scss'

export const WheelPin = ({ active, segments, duration }) => {
  const pin = useRef()

  useEffect(() => {
    if(active) {
      const started = Date.now()
      const element = pin.current
      const durations = generateDurations(segments, duration)
      let current = 0

      const triggerAnimation = duration => {
        element.style.animation = ''
        setTimeout(() => element.style.animation = `pulse-pin ${Math.max(duration, 0.01)}s`)
      }

      const showNextAnimation = () => {
        current++
        if (current < durations.length) {
          const elapsed = Date.now() - started
          const targetElapsed = sum(durations.slice(0, current)) * 1000
          const behind = elapsed - targetElapsed
          const thisDuration = durations[current] - (behind / 1000)
          triggerAnimation(thisDuration)
        }
      }
      triggerAnimation(durations[0])
      element.addEventListener('animationend', showNextAnimation)
      return () => element.removeEventListener('animationend', showNextAnimation)
    }
  }, [pin, active, segments, duration])

  return (
    <svg
      viewBox="0 0 805.8 1108.7"
      ref={pin}
      style={{
        animationTimingFunction: 'linear',
        animationIterationCount: 1,
        transformOrigin: '50% 35%'
      }}
      className="wheel-pin"
    >
      <path d="M0,402.9C0,649,280.4,970.1,402.9,1108.7c122.5-138.6,402.9-459.7,402.9-705.8S625.4,0,402.9,0,0,180.4,0,402.9h0Z" fill="white" />
    </svg>
  )
}

function generateDurations(segments, totalDuration) {
  const segmentLength = 1 / segments
  const timings = Array(segments).fill().map((_, i) =>
    ((i + 1) * segmentLength) ** 2 * totalDuration
  )
  return timings.map((x, i) => x - (timings[i - 1] || 0))
}
